module.exports = __webpack_public_path__ + "img/bem-vindo.c0ff652f.jpg";